namespace TabAurous.Sales {
    export namespace GSTR1Service {
        export const baseUrl = 'Sales/GSTR1';

        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<SalesTaxRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Sales/GSTR1/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>GSTR1Service)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
